import React, { Suspense, lazy, useState } from 'react'
import { AuthProvider, useAuth } from './auth/AuthProvider'
import { coerceViewForUser } from './auth/access'
import { LoginForm } from './auth/LoginForm'
import Header from './components/Header'
import Dashboard from './pages/Dashboard'
import Operations from './pages/Operations'
import TimelineRollup from './pages/TimelineRollup'
import TimelineProjected from './pages/TimelineProjected'
import Sales from './pages/Sales'
import Reports from './pages/Reports'
import VendorManagement from './pages/VendorManagement'
import ProcurementReview from './pages/ProcurementReview'
import ProcurementRfpDesigner from './pages/ProcurementRfpDesigner'
import ProcurementScopeAliasReview from './pages/ProcurementScopeAliasReview'
import ProcurementLeveling from './pages/ProcurementLeveling'

const WeeklySalesDashboard = lazy(() => import('./pages/WeeklySalesDashboard'))
const WeeklySalesExport = lazy(() => import('./pages/WeeklySalesExport'))

function AppContent() {
  const [currentView, setCurrentView] = useState('dashboard')
  const [operationsView, setOperationsView] = useState('milestones')
  const [procurementScopeReviewResponseId, setProcurementScopeReviewResponseId] = useState('')
  const [procurementLevelingPackageId, setProcurementLevelingPackageId] = useState('')
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="page" style={{ textAlign: 'center' }}>
        Loading...
      </div>
    )
  }

  if (!user) {
    return <LoginForm />
  }

  const resolvedView = coerceViewForUser(user, currentView)

  const handleNavigate = (view, target) => {
    setCurrentView(coerceViewForUser(user, view))

    if (view === 'operations' && target) {
      setOperationsView(target)
    }

    if (view === 'procurement-scope-review') {
      setProcurementScopeReviewResponseId(typeof target === 'string' ? target : '')
    }

    if (view === 'procurement-leveling') {
      setProcurementLevelingPackageId(typeof target === 'string' ? target : '')
    }
  }

  const renderView = () => {
    switch (resolvedView) {
      case 'operations':
        return <Operations defaultView={operationsView} />
      case 'timeline':
        return <TimelineRollup />
      case 'timeline-projected':
        return <TimelineProjected />
      case 'sales':
        return <Sales />
      case 'reports':
        return <Reports />
      case 'vendors':
        return <VendorManagement />
      case 'procurement-rfp':
        return <ProcurementRfpDesigner onNavigate={handleNavigate} />
      case 'procurement-review':
        return <ProcurementReview onNavigate={handleNavigate} />
      case 'procurement-scope-review':
        return (
          <ProcurementScopeAliasReview
            initialResponseId={procurementScopeReviewResponseId}
            onNavigate={handleNavigate}
          />
        )
      case 'procurement-leveling':
        return (
          <ProcurementLeveling
            packageId={procurementLevelingPackageId}
            onNavigate={handleNavigate}
          />
        )
      case 'weekly-sales-dashboard':
        return (
          <Suspense fallback={<div className="page" style={{ textAlign: 'center' }}>Loading...</div>}>
            <WeeklySalesDashboard />
          </Suspense>
        )
      case 'weekly-sales-export':
        return (
          <Suspense fallback={<div className="page" style={{ textAlign: 'center' }}>Loading...</div>}>
            <WeeklySalesExport />
          </Suspense>
        )
      default:
        return <Dashboard onNavigate={handleNavigate} />
    }
  }

  const isFullWidthPage = resolvedView === 'timeline' || resolvedView === 'timeline-projected' || resolvedView === 'procurement-leveling';

  return (
    <div className="app">
      <Header
        currentView={resolvedView}
        onViewChange={(view) => setCurrentView(coerceViewForUser(user, view))}
      />
      <main className={isFullWidthPage ? "main-content-fluid" : "main-content"}>
        {renderView()}
      </main>
    </div>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App

